

























import Vue from 'vue'

export default Vue.extend({
  name: 'AddRemoveButton',

  props: {
    id: {
      type: Number,
      required: true,
    },
    isSelected: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'medium',
    },
  },
})
